export const FeedBackIntent = Object.freeze({
  General: 'general',
  Triggered: 'triggered',
});

export default FeedBackIntent;
